import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, mergeMap, retryWhen } from 'rxjs/operators';

import { ExceptionService } from '../services/exception.service';


@Injectable()
export class SdErrorHttpInterceptor implements HttpInterceptor {
  private readonly MAX_NUMBER_OF_RETRY_NO_CONNECTION: number = 5;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  constructor(private readonly exceptionService: ExceptionService) {
  }

  intercept = (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> => {
    return next.handle(req).pipe(
      retryWhen(errors =>
        errors.pipe(
          mergeMap((error, attempt) => {
            // TODO: на статус 0 завязываться нельзя, тк он может быть вызван CORS или отменой запроса или другими причинами и в теории может уйти в бесконечный цикл
            const isRetryableStatus = error.status === 503 || error.status === 0;
            if (attempt >= this.MAX_NUMBER_OF_RETRY_NO_CONNECTION || error.status === 401 || !isRetryableStatus) {
              return throwError(error);
            }

            return timer(1000 * Math.pow(2, attempt));
          })
        )
      ),
      catchError(err => this.exceptionService.catchBadResponse(err))) as any;
  };
}
